module.exports = __webpack_public_path__ + "images/blue-admin-387b89db.png";